import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import { stringToArray } from '@core/Utils/Strings/StringToArray';
import { vehicleToFilterInteraction } from '@tracking/Schemas/FilterInteraction/VehicleToFilterInteraction';
import { searchFiltersToEvent } from '@tracking/Schemas/SearchFilters/SearchFiltersToEvent';
import { searchSortToEvent } from '@tracking/Schemas/SearchSort/SearchSortToEvent';
import { prepareFiltersArrayForEvent } from '@tracking/Utils/PrepareFiltersArrayForEvent';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

export function trackFilterEvent(
  filterName: string,
  filterValue: string | string[],
  filtersList: Filter[],
) {
  const sortValue = getFilterFromArray('sort', filtersList);
  const filterValueArray = stringToArray(filterValue);
  const filterInteractionEvent = vehicleToFilterInteraction({
    filterName,
    filterValue: filterValueArray as string[],
  });
  const searchFiltersEvent = searchFiltersToEvent(prepareFiltersArrayForEvent(filtersList));
  const searchSortEvent = searchSortToEvent((sortValue?.value as string) || '');

  trackCustomEvent({
    event: filterInteractionEvent!,
    context: [searchFiltersEvent, searchSortEvent],
  });
}
